import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getFamilySettingsAsync() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/setting/family', HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getChildSettingsAsync() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/setting/child', HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async updateSettingsAsync(settings) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			let { _id, requiredData, featuredData, documents } = settings;
			try {
				let res = await axios.put(
					`/setting/${_id}`,
					{
						requiredData,
						featuredData,
						documents
					},
					HEADER
				);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getSettingsNotifAsync() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/setting/notification', HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async postSettingsNotifAsync(notifications) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.post('/setting/notification', { notifications }, HEADER);
				return res;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
